import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedManagerRoute({ children }) {

  const user = JSON.parse(localStorage.getItem("user"));

  const location = useLocation();

  // ❌ Not logged in
  if (!user) {

    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(
          location.pathname
        )}`}
        replace
      />
    );
  }

  // ❌ Not manager
  if (!user?.is_manager) {

    return (
      <Navigate
        to="/home"
        replace
      />
    );
  }

  // ✅ Manager
  return children;
}